import { Box, Text, RadioGroup, Radio, Checkbox } from "@chakra-ui/react";
import ContabilizacaoTable from "../ContabilizacaoTable";
import { Flex } from "@chakra-ui/layout";
import { Control } from "react-hook-form";
import CollapsibleCard from "../CollapsibleCard";
import { Row, Col, Tooltip } from "antd";
import Field from "components/Input/Field/index";
import CardDefault from "components/Cards/CardDefault/index";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import RowTableHistorico from "./RowTableHistorico";
import {
  ExportacaoContabilForm,
  ExportacaoContabilDto,
} from "features/exportacao-contabil/typings/index";

export default function FormHistorico({
  control,
  form,
  data,
}: {
  form: ExportacaoContabilForm;
  data?: ExportacaoContabilDto;
  control: Control<ExportacaoContabilForm, object>;
}) {
  const descricaoText = `F 1234 - RAZÃO SOCIAL LTDA ${
    form.incluirDescricaoHistorico ? "- VENDA DE PRODUTO DO TIPO A" : ""
  }`;
  return (
    <Box>
      <CollapsibleCard
        titleCard="Entenda o histórico que será exportado"
        children={
          <>
            Parametrize a estrutura do histórico que será utilizado e informe o
            mesmo <strong>código do histórico</strong> padrão do seu sistema
            contábil. Dessa maneira, o seu sistema contábil identificará o
            código na <strong>importação</strong> do arquivo.
          </>
        }
      />

      <Text my={4}>
        Configure o formato da descrição do lançamento que irá ser exportado.
      </Text>

      <Box as={Row}>
        <Box as={Col} md={14}>
          <Field
            control={control}
            name="letraTipo"
            rules={{
              required: true,
            }}
            render={({ field, isInvalid }) => (
              <RadioGroup
                value={field.value}
                onChange={field.onChange}
                as={Row}
                gutter={32}
              >
                <Box as={Col} md={12}>
                  <Radio
                    isInvalid={isInvalid}
                    color={isInvalid ? "red" : undefined}
                    value={"todoMaiuscula"}
                  >
                    COM TODAS AS LETRAS MAIÚSCULAS
                  </Radio>
                </Box>
                <Box as={Col} md={12}>
                  <Radio
                    isInvalid={isInvalid}
                    color={isInvalid ? "red" : undefined}
                    value={"primeiraMaiuscula"}
                  >
                    Apenas a primeira letra minúscula
                  </Radio>
                </Box>
              </RadioGroup>
            )}
          />
        </Box>
        <Box as={Col} md={10}>
          <Field
            control={control}
            name="incluirDescricaoHistorico"
            render={({ field }) => (
              <Checkbox
                isChecked={field.value}
                onChange={() => field.onChange(!field.value)}
              >
                Incluir descrição do lançamento financeiro no histórico
              </Checkbox>
            )}
          />
        </Box>
      </Box>

      {form.letraTipo ? (
        <CardDefault my={2}>
          <Flex gap={1}>
            <Text fontWeight="bold">Exemplo: </Text>
            <Text>
              {form.letraTipo === "todoMaiuscula"
                ? `N${descricaoText.toUpperCase()}`
                : `N${descricaoText.toLowerCase()}`}
            </Text>
          </Flex>
        </CardDefault>
      ) : null}

      <Flex
        flexDir="column"
        gap={4}
        maxHeight="32dvh"
        overflowY="auto"
        className="custom-scroll-bar"
      >
        <ContabilizacaoTable
          headerTable={<HeaderHistorico categoria="transferência" />}
          rowTable={
            data?.transferencias?.length
              ? data.transferencias?.map((transferencia, index) => (
                  <RowTableHistorico
                    key={transferencia.id}
                    data={transferencia}
                    control={control}
                    index={index}
                    nameField={"transferencias"}
                  />
                ))
              : null
          }
        />
        <ContabilizacaoTable
          headerTable={<HeaderHistorico categoria="receita" />}
          rowTable={
            data?.receitas?.length
              ? data.receitas.map((receita, index) => (
                  <RowTableHistorico
                    key={receita.id}
                    data={receita}
                    control={control}
                    index={index}
                    nameField={"receitas"}
                  />
                ))
              : null
          }
        />
        <ContabilizacaoTable
          headerTable={<HeaderHistorico categoria="despesa" />}
          rowTable={
            data?.despesas?.length
              ? data.despesas.map((despesa, index) => (
                  <RowTableHistorico
                    key={despesa.id}
                    data={despesa}
                    control={control}
                    index={index}
                    nameField={"despesas"}
                  />
                ))
              : null
          }
        />
      </Flex>
    </Box>
  );
}

function HeaderHistorico({ categoria }: { categoria: string }) {
  return (
    <Flex w="100%" gap={6}>
      <Flex flex={4} fontWeight="medium">
        Categoria de {categoria}
      </Flex>
      <Flex flex={2} fontWeight="medium" align="center" gap={1}>
        Histórico padrão das provisões
        <Tooltip title="Informe o código padrão do seu sistema referente as provisões">
          <AiOutlineQuestionCircle cursor={"pointer"} size={15} />
        </Tooltip>
      </Flex>
      <Flex flex={2} fontWeight="medium" align="center" gap={1}>
        Histórico padrão das baixas
        <Tooltip title="Informe o código padrão do seu sistema referente as baixas realizadas">
          <AiOutlineQuestionCircle cursor={"pointer"} size={15} />
        </Tooltip>
      </Flex>
    </Flex>
  );
}
